import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PaginatedDriversRequest } from "../models/get-paginated-drivers-request.model";
import { PaginatedResult } from "../../../_shared/models/paginated-result.model";
import { OvertimeDriver } from "../models/overtime-drivers.model";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { environment } from "../../../../environments/environment";
import { Response, SummaryRequest } from "../../../_shared/models";
import { DriverOvertimeTotalCost } from "../models/driver-overtime-total-cost.model";
import { UpdateOvertimeStatusRequest } from "../models/update-overtime-status-request.model";
import { GetPaginatedOvertimeEntriesRequest } from "../models/get-paginated-overtime-entries-request.model";
import { Overtime } from "../models/overtime.model";
import { AccountDateFilterRequest } from "../../../_shared/models/account-date-filter-request.model";
import { DriverOvertimeActivitySummary } from "../models/driver-activity-summary.model";
import { OvertimeHoursSummary } from "../models/overtime-hours-summary.model";
import { GetDriverOvertimeTotalCostRequest } from "../models/get-overtime-total-cost-request.model";

@Injectable({
  providedIn: 'root'
})
export class OvertimeManagementService {

  constructor(
    private http: HttpClient
  ) { }

  getPaginatedDrivers(request: PaginatedDriversRequest, cancellation: Subject<void>): Promise<Response<PaginatedResult<OvertimeDriver>>> {
    return firstValueFrom(this.http.post<Response<PaginatedResult<OvertimeDriver>>>(`${environment.apiEndpoint}/overtimemanagement/paginated-drivers`, request).pipe(takeUntil(cancellation)));
  }

  getDriverOvertimeTotalCostById(request: GetDriverOvertimeTotalCostRequest): Promise<Response<DriverOvertimeTotalCost>> {
    return firstValueFrom(this.http.post<Response<DriverOvertimeTotalCost>>(`${environment.apiEndpoint}/overtimemanagement/driver-total-cost`, request));
  }

  updateOvertimeStatusById(request: UpdateOvertimeStatusRequest): Promise<Response<void>> {
    return firstValueFrom(this.http.post<Response<void>>(`${environment.apiEndpoint}/overtimemanagement/overtime-status`, request));
  }

  getPaginatedOvertime(request: GetPaginatedOvertimeEntriesRequest): Promise<Response<PaginatedResult<Overtime>>> {
    return firstValueFrom(this.http.post<Response<PaginatedResult<Overtime>>>(`${environment.apiEndpoint}/overtimemanagement/driver-overtimes`, request));
  }

  getDriverActivitySummary(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<DriverOvertimeActivitySummary>> {
    return firstValueFrom(this.http.post<Response<DriverOvertimeActivitySummary>>(`${environment.apiEndpoint}/overtimemanagement/activity-summary`, request).pipe(takeUntil(cancellation)));
  }

  getDriverOvertimeHoursSummary(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OvertimeHoursSummary>> {
    return firstValueFrom(this.http.post<Response<OvertimeHoursSummary>>(`${environment.apiEndpoint}/overtimemanagement/overtime-hours-summary`, request).pipe(takeUntil(cancellation)));
  }
}
